import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import ModalHandleErrorTransaction from './components/ModalHandleErrorTransaction';
import ModalPaypalDetail from './components/ModalPaypalDetail';
import MyContext from '../../common/MyContext';
import { canDoAccountAction } from '../../common/accountPermission.js';

// API đã chuyển sang microservice user (context-path /mc-user, controller /web/bank)
const RECHARGE_LIST_URL = '/mc-user/web/bank/recharge/list';
const REFUND_URL = '/mc-user/referral/web/refund-top-up';

const SOURCE_BADGE = {
    Vietcombank: 'badge-primary',
    VietcombankBiz: 'badge-primary',
    VietinBank: 'badge-info',
    MOMO: 'badge-danger',
    Paypal: 'badge-warning',
};

export default class TransactionManagerPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            smsList: [],
            smsListTemp: [],
            idSmsProcess: null,
            uidProcess: null,
            showProcessModal: null,
            addTime: "",
            sender: "",
            status: "",
            dateStart: null,
            dateEnd: null,
            refundingId: null, // Track đang refund transaction nào
            loading: false,
            paypalOrderIdSelected: null, // Giao dịch PayPal đang xem chi tiết
        }

        this.setIdSms = this.setIdSms.bind(this);
        this.getSmsList = this.getSmsList.bind(this);
        this.search = this.search.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.reset = this.reset.bind(this);
        this.handleRefund = this.handleRefund.bind(this);
    }

    componentDidMount() {
        this.getSmsList();
    }

    getSmsList() {
        this.setState({ loading: true });
        axios.post(global.config.apiDomain + RECHARGE_LIST_URL, {
            dateStart: null,
            dateEnd: null
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            const list = res.data?.data || [];
            this.setState({
                smsList: list,
                smsListTemp: list,
                loading: false,
            })
        }).catch(error => {
            this.setState({ loading: false });
            const msg = error.response?.data?.message || error.message || "Không tải được danh sách giao dịch";
            toast.error(msg);
        });
    }

    search() {
        let { sender, status, dateStart, dateEnd } = this.state;
        var date_1 = dateEnd
        if (date_1 == null) {
            const date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();

            if (month < 10) {
                month = "0" + month;
            }
            date_1 = year + "-" + month + "-" + day;
        }
        this.setState({ loading: true });
        axios.post(global.config.apiDomain + RECHARGE_LIST_URL, {
            dateStart: dateStart,
            dateEnd: date_1
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            var smsList_1 = res.data?.data || [];

            smsList_1 = smsList_1.filter(e => (e?.sender || "").includes(sender));
            smsList_1 = smsList_1.filter(e => (e?.status || "").includes(status));

            this.setState({
                smsList: smsList_1,
                loading: false,
            });
        }).catch(error => {
            this.setState({ loading: false });
            const msg = error.response?.data?.message || error.message || "Tìm kiếm thất bại";
            toast.error(msg);
        });
    }

    reset() {
        this.setState({
            addTime: "",
            sender: "",
            status: "",
            dateStart: null,
            dateEnd: null,
            smsList: this.state.smsListTemp
        });
    }

    handleChange(event) {
        let target = event.target;
        let name = target.name;
        let value = target.value;

        this.setState({
            [name]: value
        });
    }

    handleRefund(sms) {
        // Kiểm tra có đủ thông tin không
        if (!sms.id) {
            toast.warning("Không tìm thấy ID giao dịch");
            return;
        }

        if (!sms.icoinPlusId) {
            toast.warning("Không tìm thấy icoinPlusId");
            return;
        }

        // Xác nhận trước khi refund
        if (!window.confirm(`Bạn có chắc muốn refund giao dịch ID: ${sms.id}?`)) {
            return;
        }

        // Set loading state
        this.setState({ refundingId: sms.id });

        // Gửi request refund
        axios.post(
            `${global.config.apiDomain}${REFUND_URL}`,
            {
                smsId: sms.id,
                icoinPlusId: sms.icoinPlusId
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        ).then(res => {
            this.setState({ refundingId: null });
            if (res.data && res.data.status === "OK") {
                toast.success(res.data.message || "Refund thành công");
                // Reload danh sách
                this.getSmsList();
            } else {
                toast.warning(res.data.message || "Có lỗi xảy ra");
            }
        }).catch(error => {
            this.setState({ refundingId: null });
            const errorMessage = error.response?.data?.message || error.message || "Đã xảy ra lỗi khi refund";
            toast.error(errorMessage);
            console.error("Error refunding:", error);
        });
    }

    setIdSms(sms) {
        this.setState({
            idSmsSelected: sms.id,
            sender: sms.sender
        });
    }

    renderSourceBadge(sender) {
        const cls = SOURCE_BADGE[sender] || 'badge-secondary';
        return <span className={`badge ${cls} badge-pill px-2 py-1`}>{sender || '—'}</span>;
    }

    renderStatusBadge(status) {
        if (status === "SUCCESS") {
            return <span className="badge badge-success badge-pill px-2 py-1">SUCCESS</span>;
        }
        if (status === "FAILED") {
            return <span className="badge badge-danger badge-pill px-2 py-1">FAILED</span>;
        }
        return <span className="badge badge-secondary badge-pill px-2 py-1">{status || '—'}</span>;
    }

    render() {
        const { smsList, loading } = this.state;

        return (
            <>
                <ModalHandleErrorTransaction resetList={this.getSmsList} id={this.state.idSmsSelected} sender={this.state.sender}></ModalHandleErrorTransaction>
                <ModalPaypalDetail orderId={this.state.paypalOrderIdSelected}></ModalPaypalDetail>
                <div id="content">
                    <div className="container-fluid" style={{ maxWidth: 1280, margin: '0 auto', padding: '24px 16px' }}>
                        <div className="card border-0 shadow-sm" style={{ borderRadius: 12, overflow: 'hidden' }}>
                            {/* Header */}
                            <div className="card-header bg-white d-flex align-items-center justify-content-between py-3" style={{ borderBottom: '1px solid #eee' }}>
                                <div className="d-flex align-items-center">
                                    <i className="fas fa-exchange-alt fa-lg text-primary mr-3"></i>
                                    <div>
                                        <h4 className="mb-0 font-weight-bold">Quản lí giao dịch nạp tiền</h4>
                                        <small className="text-muted">{smsList.length} giao dịch</small>
                                    </div>
                                </div>
                                <button className="btn btn-outline-secondary btn-sm" type="button" onClick={this.getSmsList} disabled={loading}>
                                    <i className="fas fa-sync mr-1"></i> Tải lại
                                </button>
                            </div>

                            {/* Filter bar */}
                            <div className="card-body bg-light py-3" style={{ borderBottom: '1px solid #eee' }}>
                                <div className="form-row align-items-end">
                                    <div className="form-group col-6 col-md-2 mb-2">
                                        <label className="small text-muted mb-1">Nguồn</label>
                                        <select
                                            name="sender"
                                            value={this.state.sender}
                                            className="form-control form-control-sm"
                                            onChange={this.handleChange}>
                                            <option value="">Tất cả</option>
                                            <option value="Vietcombank">VCB</option>
                                            <option value="VietinBank">VTB</option>
                                            <option value="MOMO">Momo</option>
                                            <option value="Paypal">Paypal</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-6 col-md-2 mb-2">
                                        <label className="small text-muted mb-1">Trạng thái</label>
                                        <select
                                            name="status"
                                            value={this.state.status}
                                            className="form-control form-control-sm"
                                            onChange={this.handleChange}>
                                            <option value="">Tất cả</option>
                                            <option value="SUCCESS">SUCCESS</option>
                                            <option value="FAILED">FAILED</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-6 col-md-2 mb-2">
                                        <label className="small text-muted mb-1">Từ ngày</label>
                                        <input type="date" className="form-control form-control-sm"
                                            value={this.state.dateStart || ""}
                                            onChange={(e) => this.setState({ dateStart: e.target.value })} />
                                    </div>
                                    <div className="form-group col-6 col-md-2 mb-2">
                                        <label className="small text-muted mb-1">Đến ngày</label>
                                        <input type="date" className="form-control form-control-sm"
                                            value={this.state.dateEnd || ""}
                                            onChange={(e) => this.setState({ dateEnd: e.target.value })} />
                                    </div>
                                    <div className="form-group col-12 col-md-4 mb-2">
                                        <button className="btn btn-success btn-sm mr-2" type="button" onClick={this.search} disabled={loading}>
                                            <i className="fa fa-search mr-1"></i> Tìm kiếm
                                        </button>
                                        <button className="btn btn-outline-danger btn-sm" type="button" onClick={this.reset} disabled={loading}>
                                            <i className="fas fa-undo mr-1"></i> Làm mới
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table table-hover table-striped mb-0" style={{ minWidth: 900 }}>
                                    <thead style={{ backgroundColor: '#1565c0', color: '#fff' }}>
                                        <tr>
                                            <th scope="col" className="text-center">STT</th>
                                            <th scope="col">Thời gian</th>
                                            <th scope="col" className="text-right">Số tiền</th>
                                            <th scope="col" className="text-center">UID</th>
                                            <th scope="col" className="text-center">Nguồn</th>
                                            <th scope="col">Nội dung</th>
                                            <th scope="col" className="text-center">Trạng thái</th>
                                            <th scope="col" className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={8} className="text-center text-muted py-5">
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    Đang tải...
                                                </td>
                                            </tr>
                                        ) : smsList.length === 0 ? (
                                            <tr>
                                                <td colSpan={8} className="text-center text-muted py-5">
                                                    <i className="fas fa-inbox fa-2x d-block mb-2" style={{ opacity: 0.4 }}></i>
                                                    Không có giao dịch nào
                                                </td>
                                            </tr>
                                        ) : (
                                            smsList.map((sms, index) => (
                                                <tr key={sms.id}>
                                                    <th scope="row" className="text-center align-middle">{index + 1}</th>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{new Date(sms.addTime).toLocaleString('vi-VN')}</td>
                                                    <td className="align-middle text-right font-weight-bold" style={{ whiteSpace: 'nowrap' }}>
                                                        {sms.amount != null ? Number(sms.amount).toLocaleString('vi-VN') : ''}
                                                    </td>
                                                    <td className="align-middle text-center">{sms.uid || '—'}</td>
                                                    <td className="align-middle text-center">{this.renderSourceBadge(sms.sender)}</td>
                                                    <td className="align-middle" style={{ maxWidth: 260, fontSize: '0.85rem' }}>{sms.message}</td>
                                                    <td className="align-middle text-center">{this.renderStatusBadge(sms.status)}</td>
                                                    <td className="align-middle text-center" style={{ whiteSpace: 'nowrap' }}>
                                                        {/* Chi tiết chỉ có cho giao dịch PayPal (kind PayPalOrder mới lưu đủ
                                                            transactionId/icoin/user nhận icoin). */}
                                                        {sms.sender === "Paypal" &&
                                                            <button
                                                                onClick={() => this.setState({ paypalOrderIdSelected: sms.id })}
                                                                className="btn btn-sm btn-outline-primary mr-1"
                                                                data-toggle="modal"
                                                                data-target="#modalPaypalDetail"
                                                            >
                                                                <i className="fa fa-eye mr-1"></i> Chi tiết
                                                            </button>}
                                                        {sms.status === "FAILED" &&
                                                            <button
                                                                onClick={() => this.setIdSms(sms)}
                                                                className="btn btn-sm btn-danger"
                                                                data-toggle="modal"
                                                                data-target="#modalHandleRecharge"
                                                            >
                                                                <i className="fas fa-tools mr-1"></i> Xử lí
                                                            </button>}
                                                        {/* CSKH part-time được "Xử lí" giao dịch lỗi
                                                            nhưng không được hoàn tiền. */}
                                                        {sms.status === "SUCCESS" && canDoAccountAction(this.context && this.context.user, "refundTopUp") &&
                                                            <button
                                                                onClick={() => this.handleRefund(sms)}
                                                                className="btn btn-sm btn-warning"
                                                                disabled={this.state.refundingId === sms.id}
                                                            >
                                                                {this.state.refundingId === sms.id ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                                        Đang xử lý...
                                                                    </>
                                                                ) : (
                                                                    <><i className="fas fa-undo-alt mr-1"></i> Refund</>
                                                                )}
                                                            </button>}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

TransactionManagerPage.contextType = MyContext;
